module.exports = __webpack_public_path__ + "img/forgot-password.f587a60c.svg";